import CountdownCircleTimer from "../../components/AI/CountdownCircleTimer";

export const MicController = ({ listening, timer, onToggle, disabled }) => {
  return (
    <CountdownCircleTimer 
      duration={timer} 
      active={listening} 
      onClick={onToggle}
      disabled={disabled}
    />
  );
};
